import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'cwr-invoice-upload-router',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './invoice-upload-router.component.html',
    styleUrls: ['invoice-upload-router.component.scss'],
})
export class InvoiceUploadRouterComponent implements OnInit {
    constructor() {}
    ngOnInit() {}
}
